import React, { Component } from 'react';
import './DeliveryMethod.css';
import "../../CommonStyles/CSS.css"
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
//import { addToCart } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
// import { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
// const stageName = "Ship";
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import TopBar from '../../assets/components/topbar/TopBar';
import miniArrow from '../../images/public/registeration/miniarrow.png';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';

const cookies = new Cookies();

class DeliveryMethod extends Component {
	constructor(props) {
		super(props);

		//let params = null;
		//console.log('[DeliveryMethod]', params);
		this.state = {
			step: '2',
			isLoading: false,
			errmsg: null,
			errorFlg: false,
			workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
			screenData: null,
			userOptions: [],
			canProceed: false,
			helpShow: false,
			helpMessage:"",            
		};
	}

	componentDidMount() {
		// this.wf = new MPWorkFlow();
		// this.init();
		this.refresh();
	}

	// async init() {
	//     // update screenData for current states
	//     await getWorkFlow(this, stageName);
	//     this.update();
	// }

	async update() {
		// updating server state...
		let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
		//console.log('[DeliveryMethod] @update #resp', resp);
		if (!resp) return;
		if (resp.status === "success") {
			// updating localStorage
			MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
			// updating current screen
			this.refresh();
		} /* else if (resp.status === "fail") {
				this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
		} */
	}

	async refresh() {
		// update screenData for current states
		await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Ship"));
		this.setState({ canProceed: this.state.screenData.link_next != "" });
		// sorting user's options
		this.orderUserOptions();
	}

	async transit(toWhere) {
    console.log('before workflowTransition 4');
		let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
		//console.log('[DeliveryMethod] @transit #resp', resp);
		
		if (resp.status === "success") {
			// updating localStorage and navigating to the new screen
			MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
			let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
			// console.log("[DeliveryMethod] @gotoResorts #getRouteName:", nextScreen);
			return this.props.history.push(nextScreen);
		} /*else if (resp.status === "fail") {
				this.setState({ errorFlg: true, errmsg: resp.message });
		}*/

	}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ errorFlg: false })
				break;
			case "actionButton":
				if (info.option1 === "attention") {
					this.setState({ errorFlg: false })
					break;
				}
		}
	}

	/* new functions for new flow */

	// orders user's options by 'order' key inside 'options' object of screenData
	orderUserOptions() {
		// NOTE: each time an option changes, this function must be called after modifyWorkflow() call
		// order the options
		let options = Object.values(this.state.screenData.options).sort((x, y) => x.order - y.order);
		// console.log("[DeliveryMethod] @orderUserOptions #options:", options);
		this.setState({ userOptions: options });
	}

	onUserOptionChanged = (id) => {
		let index = Number(id.split("-")[2]);
		// console.log("[DeliveryMethod] @onUserOptionChanged #index:", index);
		// finding corresponding key in the object that matches the order index 
		let options = this.state.userOptions;
		// console.log("[DeliveryMethod] @onUserOptionChanged #options:", options);
		let workflowOptions = this.state.screenData.options;
		// console.log("[DeliveryMethod] @onUserOptionChanged #workflowOptions:", workflowOptions);
		const key = Object.keys(workflowOptions).find(key => workflowOptions[key].order === options[index].order);
		// console.log("[DeliveryMethod] @onUserOptionChanged #key:", key);
		// changing options and modifying workflow
		// clearing all options and setting the selected one
		options.map(opt => {  // for current screen usage
				opt.enabled = 0;
		});
		// to update the workflow
		Object.keys(workflowOptions).map(k => { // for updating the complete w.f.
				workflowOptions[k].enabled = 0;
		})
		// setting the selected option
		options[index].enabled = 1;
		workflowOptions[key].enabled = 1;
		// console.log("[DeliveryMethod] @onUserOptionChanged #workflowOptions:", workflowOptions);
		// console.log("[DeliveryMethod] @onUserOptionChanged #options:", options);
		// update current screen
		this.setState({ userOptions: options });
		// updating wf
		let screenData = this.state.screenData;
		screenData.options = workflowOptions;
		this.update();
	}

	helpShowModal=(help_tag)=>{
		MPWorkFlow.getInstance().workflowHelp(this, {tag: help_tag});
	}

	onBack=()=> {
		//return this.props.history.push('/');
		this.transit(this.state.screenData.link_back);
	}

	gotoNextStage = (e) => {
		e.preventDefault();
		this.transit(this.state.screenData.link_next);
	}

	render() {
		//console.log('[DeliveryMethod]', this.state);
		return (
			<Router>
				<div>
					<div>
						<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
							<div className="row flex-nowrap">
								<div className="col-2 d-flex align-items-center">
									<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
								</div>
								<div className="col-8 d-flex align-items-center justify-content-center">
									<img className="sn_mobile_top_row_logo" src={ logo } />
								</div>
								<div className="col-2 d-flex align-items-center justify-content-end">
									<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help }/></button>
								</div>
							</div>
						</div>
						<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
            <div className="sn_overlay d-lg-none"></div>
						<div className="sn_delivery">
							<div className="container">
								<div className="row">
									<div className="col-12 col-lg-8 mx-auto">
										<div className="sn_register__container p-3 p-lg-5">
											<div className="row mb-3 d-none d-lg-flex">
												<div className="col-12 d-flex justify-content-end">
													<div className="sn_quest">
														{ this.state.screenData && this.state.screenData.help_tag && <a onClick={ ()=>this.helpShowModal(this.state.screenData.help_tag) }><img src={ help }/></a> }
													</div>
												</div>
											</div>
											<div className="row mb-3">
												<div className="col-12">
													<h3 className="mb-2 text-center">{ this.state.screenData && HtmlWrapper(this.state.screenData.title) }</h3>
													<p className="mb-5 text-center">{ this.state.screenData && HtmlWrapper(this.state.screenData.desc) }</p>
													<div>
													{
														this.state.userOptions.map((option, index) => {
															return <UserOptions
																key={`user-option-key-${index}`}
																id={`user-option-${index}`}
																option={option}
																onChange={this.onUserOptionChanged}
															/>
														})
													}
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end mb-3">
													<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
													<button disabled={!this.state.canProceed} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
												</div>
											</div>
											<div className="row d-lg-none mt-5">
												<div className="col-12">
													<ProgressBullets step={ this.state.step } />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{
							this.state.errorFlg ?
							<div className="containerModal">
							{
								this.state.errorFlg ?
								<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
							}
							</div> : null
						}
					</div>
					<WaitLoad enable={this.state.workFlowInProgress} />
					{ this.state.helpShow &&<InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })}/>}
				</div>
			</Router>
		);
	}
}

export default DeliveryMethod;

class UserOptions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			refresh: true,
			}
			this.myRef = React.createRef();
	}

	onChange = (e) => {
		this.props.onChange(this.props.id);
	}

	render() {
		return (
			<div className="row mt-3" onClick={ this.onChange }>
				<div className="col-2 d-flex justify-content-center">
					<div className="circle-base-outlined sn_stc">
						{ this.props.option.enabled === 1 && <div className="circle-base-inside" /> }
					</div>
				</div>
				<div className="col-10">
					<p className="sn_delivery__color">
						{ HtmlWrapper(this.props.option.title) }
						<br/>
						{ HtmlWrapper(this.props.option.desc) }
					</p>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/DeliveryMethod/DeliveryMethod.js